// extracted by mini-css-extract-plugin
export default {"root":"_1H5tb"};